export const HOTSPOT_TYPE = {
    TARGET: 1,
    OPEN_SELECT: 2,
    TEXT_VARIABLE: 3,
    FORM: 4,
    IMAGE_VARIABLE: 5,
    ELEARNING_ACCESS: 6
};
export const ACTION_TYPE = {
    POPUP: 1,
    HYPERLINK: 2,
    TIME_JUMP: 3,
    VISUAL: 4,
    PAUSE: 5,
    FORM: 6,
    MOVE_TO_CAMPAIGN: 7,
    START_ELEARNING: 8,
    SHOW_CERTIFICATE: 9,
    SOCIAL_SHARE: 10
};
